import React, { ReactNode } from 'react';

interface SectionTitleProps {
  children: ReactNode;
  right?: ReactNode;
}

/**
 * SectionTitle component for displaying section headings with optional right-aligned content
 *
 * @param children - The main title content
 * @param right - Optional content to display on the right side
 */
const SectionTitle: React.FC<SectionTitleProps> = ({ children, right }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBottom: 10,
      paddingTop: 16,
    }}
  >
    <div
      style={{
        fontSize: 14,
        lineHeight: '20px',
        fontWeight: 700,
        marginBottom: 0,
      }}
    >
      {children}
    </div>
    {right}
  </div>
);

export default SectionTitle;
